import {
  Patient,
  convertRISAPhoneNumberToAvailityPhoneNumber,
} from "risa-data-model";
import {
  generateFullName,
  getMemberIdOfPatient,
} from "./generateOrderDataForTable";
import moment from "moment";
import { PatientDetails } from "../data-model/PatientDetails";
import _ from "lodash";

export const generatePatientDataForSinglePatient = (
  patient?: Patient,
): PatientDetails => {
  const patientName = generateFullName(
    patient?.Demographics?.FirstName || "",
    patient?.Demographics?.MiddleName || "",
    patient?.Demographics?.LastName || "",
  );

  const patientId = getMemberIdOfPatient(patient as Patient) || "N/A";
  const age = `${moment().diff(patient?.Demographics?.DOB, "years")}` || "N/A";
  const patientImageUrl = undefined;
  const dob = moment(patient?.Demographics?.DOB).format("DD/MM/YYYY") || "N/A";
  const address = patient?.Demographics?.Address?.StreetAddress || "N/A";
  const primaryProvider = undefined;

  const gender = patient?.Demographics?.Sex || "N/A";
  const contactNumber =
    convertRISAPhoneNumberToAvailityPhoneNumber(
      patient?.Demographics?.PhoneNumber,
    ) || "N/A";

  return {
    patientName,
    patientId,
    age,
    patientImageUrl,
    dob,
    address,
    primaryProvider,
    gender,
    contactNumber,
  };
};

export const generatePatientDataForPrimaryDetailsComponent = (
  patientDetails: PatientDetails,
): {
  headerText: string;
  subText: string;
}[] => {
  return [
    // {
    //   headerText: "Primary Care Provider",
    //   subText: _.startCase(_.toLower(patientDetails?.primaryProvider)) || "--",
    // },
    {
      headerText: "DOB",
      subText: patientDetails?.dob || "--",
    },
    {
      headerText: "Address",
      subText: _.startCase(_.toLower(patientDetails?.address)) || "--",
    },
    {
      headerText: "Gender",
      subText: _.capitalize(patientDetails?.gender) || "--",
    },
    {
      headerText: "Contact Number",
      subText: patientDetails?.contactNumber || "--",
    },
  ];
};
